import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { I as InputGroupText } from "../../../../../FlashFormInputTextFieldModifierButtonIcon-f8b9669c.js";
import FlashFormInputTextField from "../../../../atoms/forms/inputs/FlashFormInputTextField/FlashFormInputTextField.js";
import FlashFormInputTextFieldModifierButtonClear from "../../../../atoms/forms/inputs/FlashFormInputTextField/modifiers/FlashFormInputTextFieldModifierButtonClear.js";
import { useFlashInputFocus } from "../../../../atoms/forms/inputs/hooks/useFlashInputFocus.js";
import { COMMON_CLASSNAME } from "../../../../constants.js";
import i18n from "../../../../../i18n/index.js";
import { FlashFormInputPhoneNumberCountryCodeSelect } from "./FlashFormInputPhoneNumberCountryCodeSelect.js";
import { usePhoneCountryOptions } from "./usePhoneCountryOptions.js";
import { I as I18nextProvider } from "../../../../../I18nextProvider-16dc4551.js";
import { M as Metadata, i as isObject, w as withMetadataArgument } from "../../../../../getCountryCallingCode-1d4ae7fd.js";
import { n as normalizeArguments$1, p as parsePhoneNumberWithError, c as checkNumberLength, P as ParseError, f as formatNationalNumberUsingFormat, a as parseDigits, F as FIRST_GROUP_PATTERN, b as applyInternationalSeparatorStyle, V as VALID_PUNCTUATION, e as extractCountryCallingCode, d as extractNationalNumberFromPossiblyIncompleteNumber, s as stripIddPrefix, g as extractCountryCallingCodeFromInternationalNumberWithoutPlusSign, h as VALID_DIGITS, i as PLUS_CHARS, j as getCountryByCallingCode, k as getCountryByNationalNumber, l as PhoneNumber, m as isViablePhoneNumber, o as parse, q as isPossiblePhoneNumber, r as parseIncompletePhoneNumber } from "../../../../../normalizeArguments-0e96c5c2.js";
import "../../../../../index-e71f83b5.js";
import "../../../../../_commonjsHelpers-0c53d963.js";
import "../../../../../utils-f8d1c624.js";
import "../../../../atoms/buttons/FlashButton/FlashButton.js";
import "../../../../../sass/sass.js";
import "../../../../atoms/info/FlashBadge/FlashBadge.js";
import "../../../../atoms/info/FlashSpinner/FlashSpinner.js";
import "../../../../atoms/buttons/FlashButtonGeneric.js";
import "../../../../../index-5e4e4f4b.js";
import "../../../../../axios-5f69b112.js";
import "../../../../../Button-9f0631d3.js";
import "../../../../../hooks/useInsights/useInsights.js";
import "../../../../../utils/noOp.js";
import "../../../../../hooks/useLogger/constants.js";
import "../../../../../hooks/useLogger/useLogger.js";
import "../../../../../hooks/useLogger/LoggerContext.js";
import "../../../../../hooks/useLogger/types.js";
import "../../../../../hooks/useInsights/InsightsContext.js";
import "../../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../../index-2d889c01.js";
import "../../../../../hooks/useInsights/utils.js";
import "../../../../../utils/invokeFn.js";
import "../../../../atoms/buttons/FlashButton/constants.js";
import "../../../../../Input-66ed3224.js";
import "../../../../../InputGroup-94a9774d.js";
import "../../../../../Dropdown-949fe713.js";
import "../../../../../Manager-52cb3832.js";
import "../../../../atoms/forms/FlashFormFieldLabel/FlashFormFieldLabel.js";
import "../../../../atoms/forms/FlashFormFieldValidationMessage/FlashFormFieldValidationMessages.js";
import "../../../../atoms/forms/FlashFormFieldValidationMessage/FlashFormFieldValidationMessage.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AccessTime.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AccessTimeFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AccountCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AccountCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Add.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AddCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AddLocation.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AddLocationFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Analytics.js";
import "../../../../../styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Apartment.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Apps.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeft.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeftFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRight.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRightFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowDownward.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ArrowUpward.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Bolt.js";
import "../../../../../styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/BugReport.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Business.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Calculate.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CalculateFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Cancel.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CheckCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Circle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Close.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CoPresent.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CoPresentFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ContentCopy.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CopyAll.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CreditCard.js";
import "../../../../../styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Dashboard.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Delete.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DisabledByDefault.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DisabledByDefaultFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/DoNotDisturb.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Edit.js";
import "../../../../../styles/assets/images/icons/material/designSystem/EditFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Error.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/EventFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ExpandContent.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ExpandLess.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Favorite.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FileCopy.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FileCopyFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FilterAltFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/FirstPage.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Forward.js";
import "../../../../../styles/assets/images/icons/material/designSystem/GarageHome.js";
import "../../../../../styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/GridView.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Group.js";
import "../../../../../styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Help.js";
import "../../../../../styles/assets/images/icons/material/designSystem/HelpFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/HideSource.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Home.js";
import "../../../../../styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Info.js";
import "../../../../../styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/IosShare.js";
import "../../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowDown.js";
import "../../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import "../../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "../../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowUp.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LastPage.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Link.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ListAlt.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LocalLibraryFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LocationOn.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LocationOnFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LockOpen.js";
import "../../../../../styles/assets/images/icons/material/designSystem/LockReset.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Logout.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Loop.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Mail.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MailFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Menu.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MoreHoriz.js";
import "../../../../../styles/assets/images/icons/material/designSystem/MoreVert.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NetworkCheck.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationImportant.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationImportantFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Notifications.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsActive.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsActiveFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsOff.js";
import "../../../../../styles/assets/images/icons/material/designSystem/NotificationsOffFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Paid.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PaidFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Pending.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Percent.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Person.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PersonAdd.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PersonAddFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PhoneDisabled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PhoneDisabledFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PointOfSale.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PriceChange.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PriceCheck.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Publish.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PublishFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PushPin.js";
import "../../../../../styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/QuestionMark.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Receipt.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ReceiptFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Refresh.js";
import "../../../../../styles/assets/images/icons/material/designSystem/RemoveCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/RemoveCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Replay.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Reply.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Restore.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Route.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Save.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SaveFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Schedule.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Search.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Security.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Settings.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Shield.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Smartphone.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Square.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SquareFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircle.js";
import "../../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircleFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/TableView.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Tune.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Undo.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Update.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Videocam.js";
import "../../../../../styles/assets/images/icons/material/designSystem/VideocamFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ViewList.js";
import "../../../../../styles/assets/images/icons/material/designSystem/ViewListFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Visibility.js";
import "../../../../../styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Warning.js";
import "../../../../../styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "../../../../../styles/assets/images/icons/material/designSystem/WiFi.js";
import "../../../../../styles/assets/images/icons/material/designSystem/WiFiOff.js";
import "../../../../../styles/assets/images/icons/material/designSystem/Work.js";
import "../../../../../styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "../../../../../styles/assets/images/icons/brands/GoogleG.js";
import "../../../../atoms/forms/utils/getFieldStatus.js";
import "../../../../../i18n/translations/en.js";
import "../../../../../i18n/translations/es.js";
import "../../../../../i18nInstance-89725fcb.js";
import "react-select";
import "../FlashFormInputRichSelect/FlashFormInputRichSelect.js";
import "react-dom";
import "../../../../atoms/popups/FlashModal/FlashModal.js";
import "../../../../../Fade-1a465599.js";
import "../../../../../Transition-c07376a3.js";
import "../../../../../hooks/useWindowSize/useWindowSize.js";
import "../../../../../hooks/useWindowSize/WindowSizeContext.js";
import "../../../../../isObject-ec23ace2.js";
import "../../../../../isSymbol-c6f5cd95.js";
import "../../../../atoms/popups/FlashModal/FlashModalUtils.js";
import "../../../../../useTranslation-cf39c293.js";
import "../../../../../keysIn-f10bd97a.js";
import "../../../../../_arrayLikeKeys-44b287e6.js";
import "../../../../atoms/popups/FlashModal/useFlashModal.js";
import "../../../../../useReactSelectFlashStyles-0a417fd5.js";
import "../../../../../_Uint8Array-806c1b52.js";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj[key] = value, obj;
}
function validatePhoneNumberLength$1() {
  var _normalizeArguments = normalizeArguments$1(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
  options = _objectSpread(_objectSpread({}, options), {}, {
    extract: !1
  });
  try {
    var phoneNumber = parsePhoneNumberWithError(text, options, metadata);
    metadata = new Metadata(metadata), metadata.selectNumberingPlan(phoneNumber.countryCallingCode);
    var result = checkNumberLength(phoneNumber.nationalNumber, metadata);
    if (result !== "IS_POSSIBLE")
      return result;
  } catch (error) {
    if (error instanceof ParseError)
      return error.message;
    throw error;
  }
}
function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$5(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$5(Constructor.prototype, protoProps), staticProps && _defineProperties$5(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
var AsYouTypeState = /* @__PURE__ */ function() {
  function AsYouTypeState2(_ref) {
    var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
    _classCallCheck$5(this, AsYouTypeState2), this.onCountryChange = onCountryChange, this.onCallingCodeChange = onCallingCodeChange;
  }
  return _createClass$5(AsYouTypeState2, [{
    key: "reset",
    value: function(_ref2) {
      var country = _ref2.country, callingCode = _ref2.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this[key] = properties[key];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(country, callingCode) {
      this.setCountry(country), this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function(country) {
      this.country = country, this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function(callingCode) {
      this.callingCode = callingCode, this.onCallingCodeChange(callingCode, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(country, callingCode) {
      this.international = !0, this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "appendDigits",
    value: function(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), AsYouTypeState2;
}();
function _createForOfIteratorHelperLoose$2(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i = 0;
    return function() {
      return i >= o.length ? { done: !0 } : { done: !1, value: o[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$5(o, minLen);
  }
}
function _arrayLikeToArray$5(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
var DIGIT_PLACEHOLDER = "x", DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
function repeat(string, times) {
  if (times < 1)
    return "";
  for (var result = ""; times > 1; )
    times & 1 && (result += string), times >>= 1, string += string;
  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  return string[cutBeforeIndex] === ")" && cutBeforeIndex++, stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function stripNonPairedParens(string) {
  for (var dangling_braces = [], i = 0; i < string.length; )
    string[i] === "(" ? dangling_braces.push(i) : string[i] === ")" && dangling_braces.pop(), i++;
  var start = 0, cleared_string = "";
  dangling_braces.push(string.length);
  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
    var index = _dangling_braces[_i];
    cleared_string += string.slice(start, index), start = index + 1;
  }
  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  for (var _iterator2 = _createForOfIteratorHelperLoose$2(digits.split("")), _step2; !(_step2 = _iterator2()).done; ) {
    var digit = _step2.value;
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0)
      return;
    position = template.search(DIGIT_PLACEHOLDER_MATCHER), template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }
  return [template, position];
}
function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix, matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
  if (matcher.test(state.nationalSignificantNumber))
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata,
      shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix
    });
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === "IS_POSSIBLE";
}
function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  if (state.nationalSignificantNumber, state.international, state.nationalPrefix, state.carrierCode, shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix,
      metadata
    });
    if (formattedNumber)
      return formattedNumber;
  }
  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix,
    metadata
  });
}
function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix, formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata
  });
  if (useNationalPrefixFormattingRule || (state.nationalPrefix ? formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber : state.complexPrefixBeforeNationalSignificantNumber && (formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + " " + formattedNationalNumber)), isValidFormattedNationalNumber(formattedNationalNumber, state))
    return formattedNationalNumber;
}
function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}
function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$4(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$4(Constructor.prototype, protoProps), staticProps && _defineProperties$4(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
var PatternParser = /* @__PURE__ */ function() {
  function PatternParser2() {
    _classCallCheck$4(this, PatternParser2);
  }
  return _createClass$4(PatternParser2, [{
    key: "parse",
    value: function(pattern) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(pattern), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
      if (branches)
        return {
          op: "|",
          args: branches.concat([expandSingleElementArray(instructions)])
        };
      if (instructions.length === 0)
        throw new Error("Pattern is required");
      return instructions.length === 1 ? instructions[0] : instructions;
    }
  }, {
    key: "startContext",
    value: function(context) {
      this.context.push(context);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(pattern) {
      if (!pattern)
        throw new Error("Pattern is required");
      var match = pattern.match(OPERATOR);
      if (!match) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern))
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(""));
        return;
      }
      var operator = match[1], before = pattern.slice(0, match.index), rightPart = pattern.slice(match.index + operator.length);
      switch (operator) {
        case "(?:":
          before && this.parsePattern(before), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (before && this.parsePattern(before), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var _this$getContext = this.getContext(), branches = _this$getContext.branches;
          branches.push(expandSingleElementArray(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: branches
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (before && this.parsePattern(before), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          before && this.parsePattern(before), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: parseOneOfSet(before)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(operator));
      }
      rightPart && this.parsePattern(rightPart);
    }
  }]), PatternParser2;
}();
function parseOneOfSet(pattern) {
  for (var values = [], i = 0; i < pattern.length; ) {
    if (pattern[i] === "-") {
      if (i === 0 || i === pattern.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      for (var prevValue = pattern[i - 1].charCodeAt(0) + 1, nextValue = pattern[i + 1].charCodeAt(0) - 1, value = prevValue; value <= nextValue; )
        values.push(String.fromCharCode(value)), value++;
    } else
      values.push(pattern[i]);
    i++;
  }
  return values;
}
var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/, OPERATOR = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function expandSingleElementArray(array) {
  return array.length === 1 ? array[0] : array;
}
function _createForOfIteratorHelperLoose$1(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i = 0;
    return function() {
      return i >= o.length ? { done: !0 } : { done: !1, value: o[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$4(o, minLen);
  }
}
function _arrayLikeToArray$4(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$3(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$3(Constructor.prototype, protoProps), staticProps && _defineProperties$3(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
var PatternMatcher = /* @__PURE__ */ function() {
  function PatternMatcher2(pattern) {
    _classCallCheck$3(this, PatternMatcher2), this.matchTree = new PatternParser().parse(pattern);
  }
  return _createClass$3(PatternMatcher2, [{
    key: "match",
    value: function(string) {
      var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
      if (!string)
        throw new Error("String is required");
      var result = _match(string.split(""), this.matchTree, !0);
      if (result && result.match && delete result.matchedChars, !(result && result.overflow && !allowOverflow))
        return result;
    }
  }]), PatternMatcher2;
}();
function _match(characters, tree, last) {
  if (typeof tree == "string") {
    var characterString = characters.join("");
    return tree.indexOf(characterString) === 0 ? characters.length === tree.length ? {
      match: !0,
      matchedChars: characters
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : characterString.indexOf(tree) === 0 ? last && characters.length > tree.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: characters.slice(0, tree.length)
    } : void 0;
  }
  if (Array.isArray(tree)) {
    for (var restCharacters = characters.slice(), i = 0; i < tree.length; ) {
      var subtree = tree[i], result = _match(restCharacters, subtree, last && i === tree.length - 1);
      if (result) {
        if (result.overflow)
          return result;
        if (result.match) {
          if (restCharacters = restCharacters.slice(result.matchedChars.length), restCharacters.length === 0)
            return i === tree.length - 1 ? {
              match: !0,
              matchedChars: characters
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (result.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(result, null, 2)));
        }
      } else
        return;
      i++;
    }
    return last ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }
  switch (tree.op) {
    case "|":
      for (var partialMatch, _iterator = _createForOfIteratorHelperLoose$1(tree.args), _step; !(_step = _iterator()).done; ) {
        var branch = _step.value, _result = _match(characters, branch, last);
        if (_result) {
          if (_result.overflow)
            return _result;
          if (_result.match)
            return {
              match: !0,
              matchedChars: _result.matchedChars
            };
          if (_result.partialMatch)
            partialMatch = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(_result, null, 2)));
        }
      }
      return partialMatch ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var _iterator2 = _createForOfIteratorHelperLoose$1(tree.args), _step2; !(_step2 = _iterator2()).done; ) {
        var _char = _step2.value;
        if (characters[0] === _char)
          return characters.length === 1 ? {
            match: !0,
            matchedChars: characters
          } : last ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [_char]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i = 0;
    return function() {
      return i >= o.length ? { done: !0 } : { done: !1, value: o[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$3(o, minLen);
  }
}
function _arrayLikeToArray$3(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$2(Constructor.prototype, protoProps), staticProps && _defineProperties$2(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
var DUMMY_DIGIT = "9", LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15, LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH), NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/, CREATE_CHARACTER_CLASS_PATTERN = function() {
  return /\[([^\[\]])*\]/g;
}, CREATE_STANDALONE_DIGIT_PATTERN = function() {
  return /\d(?=[^,}][^,}])/g;
}, NON_ALTERING_FORMAT_REG_EXP = new RegExp("[" + VALID_PUNCTUATION + "]*\\$1[" + VALID_PUNCTUATION + "]*(\\$\\d[" + VALID_PUNCTUATION + "]*)*$"), MIN_LEADING_DIGITS_LENGTH = 3, AsYouTypeFormatter = /* @__PURE__ */ function() {
  function AsYouTypeFormatter2(_ref) {
    _ref.state;
    var metadata = _ref.metadata;
    _classCallCheck$2(this, AsYouTypeFormatter2), this.metadata = metadata, this.resetFormat();
  }
  return _createClass$2(AsYouTypeFormatter2, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(numberingPlan, state) {
      this.resetFormat(), numberingPlan ? (this.isNANP = numberingPlan.callingCode() === "1", this.matchingFormats = numberingPlan.formats(), state.nationalSignificantNumber && this.narrowDownMatchingFormats(state)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(nextDigits, state) {
      var _this = this;
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata))
        for (var _iterator = _createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done; ) {
          var format2 = _step.value, formattedCompleteNumber = formatCompleteNumber(state, format2, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(format3) {
              return _this.shouldTryNationalPrefixFormattingRule(format3, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(format3) {
              return _this.getSeparatorAfterNationalPrefix(format3);
            }
          });
          if (formattedCompleteNumber)
            return this.resetFormat(), this.chosenFormat = format2, this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state), this.populatedNationalNumberTemplate = formattedCompleteNumber, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER), formattedCompleteNumber;
        }
      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat, newlyChosenFormat = this.chooseFormat(state);
      if (newlyChosenFormat)
        return newlyChosenFormat === previouslyChosenFormat ? this.formatNextNationalNumberDigits(nextDigits) : this.formatNextNationalNumberDigits(state.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(_ref2) {
      var _this2 = this, nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international, leadingDigits = nationalSignificantNumber, leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;
      leadingDigitsPatternIndex < 0 && (leadingDigitsPatternIndex = 0), this.matchingFormats = this.matchingFormats.filter(function(format) {
        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(format, international, nationalPrefix) {
      return !(nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length;
      if (leadingDigitsPatternsCount === 0)
        return !0;
      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex];
      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH)
        try {
          return new PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: !0
          }) !== void 0;
        } catch (error) {
          return console.error(error), !0;
        }
      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function(state) {
      for (var _this3 = this, _loop = function() {
        var format = _step2.value;
        return _this3.chosenFormat === format ? "break" : NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international)) ? _this3.createTemplateForFormat(format, state) ? (_this3.chosenFormat = format, "break") : (_this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
          return _ !== format;
        }), "continue") : "continue";
      }, _iterator2 = _createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done; ) {
        var _ret = _loop();
        if (_ret === "break")
          break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(format, state) {
      if (!(format.pattern().indexOf("|") >= 0)) {
        var template = this.getTemplateForFormat(format, state);
        if (template)
          return this.setNationalNumberTemplate(template, state), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(format) {
      return this.isNANP || format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(_ref3, options) {
      var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
      return IDDPrefix ? options && options.spacing === !1 ? IDDPrefix : IDDPrefix + " " : missingPlus ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(state) {
      if (this.template) {
        for (var index = -1, i = 0, internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
          spacing: !1
        }) : ""; i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length; )
          index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1), i++;
        return cutAndStripNonPairedParens(this.template, index + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(template, state) {
      this.nationalNumberTemplate = template, this.populatedNationalNumberTemplate = template, this.populatedNationalNumberTemplatePosition = -1, state.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + " " + template : this.template = template;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(format, _ref4) {
      var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber, pattern = format.pattern();
      pattern = pattern.replace(CREATE_CHARACTER_CLASS_PATTERN(), "\\d").replace(CREATE_STANDALONE_DIGIT_PATTERN(), "\\d");
      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0];
      if (!(nationalSignificantNumber.length > digits.length)) {
        var strictPattern = new RegExp("^" + pattern + "$"), nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT);
        strictPattern.test(nationalNumberDummyDigits) && (digits = nationalNumberDummyDigits);
        var numberFormat = this.getFormatFormat(format, international), nationalPrefixIncludedInTemplate;
        if (this.shouldTryNationalPrefixFormattingRule(format, {
          international,
          nationalPrefix
        })) {
          var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule());
          if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || "") + parseDigits("$1") && (numberFormat = numberFormatWithNationalPrefix, nationalPrefixIncludedInTemplate = !0, nationalPrefix))
            for (var i = nationalPrefix.length; i > 0; )
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER), i--;
        }
        var template = digits.replace(new RegExp(pattern), numberFormat).replace(new RegExp(DUMMY_DIGIT, "g"), DIGIT_PLACEHOLDER);
        return nationalPrefixIncludedInTemplate || (complexPrefixBeforeNationalSignificantNumber ? template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + " " + template : nationalPrefix && (template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template)), international && (template = applyInternationalSeparatorStyle(template)), template;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
      if (!result) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = result[0], this.populatedNationalNumberTemplatePosition = result[1], cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(format, _ref5) {
      var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
      if (format.nationalPrefixFormattingRule()) {
        var usesNationalPrefix = format.usesNationalPrefix();
        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international)
          return !0;
      }
    }
  }]), AsYouTypeFormatter2;
}();
function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$2(o, minLen);
  }
}
function _arrayLikeToArray$2(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$1(Constructor.prototype, protoProps), staticProps && _defineProperties$1(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = "[" + VALID_PUNCTUATION + VALID_DIGITS + "]+", VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp("^" + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + "$", "i"), VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + PLUS_CHARS + "][" + VALID_PUNCTUATION + VALID_DIGITS + "]*|[" + VALID_PUNCTUATION + VALID_DIGITS + "]+)", AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp("[^" + VALID_PUNCTUATION + VALID_DIGITS + "]+.*$"), COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/, AsYouTypeParser = /* @__PURE__ */ function() {
  function AsYouTypeParser2(_ref) {
    var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
    _classCallCheck$1(this, AsYouTypeParser2), this.defaultCountry = defaultCountry, this.defaultCallingCode = defaultCallingCode, this.metadata = metadata, this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }
  return _createClass$1(AsYouTypeParser2, [{
    key: "input",
    value: function(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text), _extractFormattedDigi2 = _slicedToArray$2(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1], digits = parseDigits(formattedDigits), justLeadingPlus;
      return hasPlus && (state.digits || (state.startInternationalNumber(), digits || (justLeadingPlus = !0))), digits && this.inputDigits(digits, state), {
        digits,
        justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(nextDigits, state) {
      var digits = state.digits, hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3;
      if (state.appendDigits(nextDigits), hasReceivedThreeLeadingDigits && this.extractIddPrefix(state), this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state))
          return;
      } else
        state.appendNationalSignificantNumberDigits(nextDigits);
      state.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
        return state.update(stateUpdate);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(_ref2) {
      var international = _ref2.international, callingCode = _ref2.callingCode;
      return international && !callingCode;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(state) {
      var _extractCountryCallin = extractCountryCallingCode("+" + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
      if (countryCallingCode)
        return state.setCallingCode(countryCallingCode), state.update({
          nationalSignificantNumber: number
        }), !0;
    }
  }, {
    key: "reset",
    value: function(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = !0;
        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(nationalDigits, setState) {
      if (this.hasSelectedNumberingPlan) {
        var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
        if (nationalNumber !== nationalDigits)
          return this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode;
        if (nationalNumber !== prevNationalSignificantNumber)
          return this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber, nationalSignificantNumberMatchesInput, nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber);
      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = !0;
        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex);
        prefixBeforeNationalNumber !== nationalPrefix && (complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber);
      }
      setState({
        nationalPrefix,
        carrierCode,
        nationalSignificantNumber,
        nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(state) {
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
        return state.update(stateUpdate);
      }))
        return !0;
      if (this.extractIddPrefix(state))
        return this.extractCallingCodeAndNationalSignificantNumber(state), !0;
      if (this.fixMissingPlus(state))
        return this.extractCallingCodeAndNationalSignificantNumber(state), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(state) {
      var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits;
      if (state.nationalSignificantNumber, !(international || IDDPrefix)) {
        var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (numberWithoutIDD !== void 0 && numberWithoutIDD !== digits)
          return state.update({
            IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
          }), this.startInternationalNumber(state, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode;
        if (_extractCountryCallin2.number, newCallingCode)
          return state.update({
            missingPlus: !0
          }), this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(state, _ref3) {
      var country = _ref3.country, callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode), state.nationalSignificantNumber && (state.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(state) {
      this.extractCountryCallingCode(state) && this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
        return state.update(stateUpdate);
      });
    }
  }]), AsYouTypeParser2;
}();
function extractFormattedPhoneNumber(text) {
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);
  if (!(startsAt < 0)) {
    text = text.slice(startsAt);
    var hasPlus;
    return text[0] === "+" && (hasPlus = !0, text = text.slice(1)), text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ""), hasPlus && (text = "+" + text), text;
  }
}
function _extractFormattedDigitsAndPlus(text) {
  var extractedNumber = extractFormattedPhoneNumber(text) || "";
  return extractedNumber[0] === "+" ? [extractedNumber.slice(1), !0] : [extractedNumber];
}
function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = _slicedToArray$2(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1];
  return VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits) || (formattedDigits = ""), [formattedDigits, hasPlus];
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$1(o, minLen);
  }
}
function _arrayLikeToArray$1(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
var AsYouType = /* @__PURE__ */ function() {
  function AsYouType2(optionsOrDefaultCountry, metadata) {
    _classCallCheck(this, AsYouType2), this.metadata = new Metadata(metadata);
    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = _slicedToArray$1(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1];
    this.defaultCountry = defaultCountry, this.defaultCallingCode = defaultCallingCode, this.reset();
  }
  return _createClass(AsYouType2, [{
    key: "getCountryAndCallingCode",
    value: function(optionsOrDefaultCountry) {
      var defaultCountry, defaultCallingCode;
      return optionsOrDefaultCountry && (isObject(optionsOrDefaultCountry) ? (defaultCountry = optionsOrDefaultCountry.defaultCountry, defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode) : defaultCountry = optionsOrDefaultCountry), defaultCountry && !this.metadata.hasCountry(defaultCountry) && (defaultCountry = void 0), [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(text) {
      var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
      if (justLeadingPlus)
        this.formattedOutput = "+";
      else if (digits) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var formattedNationalNumber;
        if (this.metadata.hasSelectedNumberingPlan() && (formattedNationalNumber = this.formatter.format(digits, this.state)), formattedNationalNumber === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var nationalDigits = this.state.getNationalDigits();
          nationalDigits && (formattedNationalNumber = this.formatter.format(nationalDigits, this.state));
        }
        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var _this = this;
      return this.state = new AsYouTypeState({
        onCountryChange: function(country) {
          _this.country = country;
        },
        onCallingCodeChange: function(callingCode, country) {
          _this.metadata.selectNumberingPlan(country, callingCode), _this.formatter.reset(_this.metadata.numberingPlan, _this.state), _this.parser.reset(_this.metadata.numberingPlan);
        }
      }), this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          _this.determineTheCountryIfNeeded(), _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var digits = this.state.digits;
      if (digits)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var country = this.state.country;
      return country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(formattedNationalNumber) {
      var _this2 = this;
      if (this.isInternational()) {
        var prefix = function(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: !!text
          }) + text;
        }, callingCode = this.state.callingCode;
        return prefix(callingCode ? formattedNationalNumber ? "".concat(callingCode, " ").concat(formattedNationalNumber) : callingCode : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix, number = nationalSignificantNumber, prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
      return prefix && (number = prefix + number), number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var number = this.getNonFormattedNumber();
      if (number)
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var callingCode = this.state.callingCode, countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber;
      if (digits) {
        if (this.isInternational())
          return callingCode ? "+" + callingCode + nationalSignificantNumber : "+" + digits;
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return "+" + callingCode_ + nationalSignificantNumber;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode, country = this._getCountry();
      if (nationalSignificantNumber && !(!country && !callingCode)) {
        if (country && country === this.defaultCountry) {
          var metadata = new Metadata(this.metadata.metadata);
          metadata.selectNumberingPlan(country);
          var _callingCode = metadata.numberingPlan.callingCode(), ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);
          if (ambiguousCountries.length > 1) {
            var exactCountry = getCountryByNationalNumber(nationalSignificantNumber, {
              countries: ambiguousCountries,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            exactCountry && (country = exactCountry);
          }
        }
        var phoneNumber = new PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
        return carrierCode && (phoneNumber.carrierCode = carrierCode), phoneNumber;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var phoneNumber = this.getNumber();
      return phoneNumber ? phoneNumber.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var phoneNumber = this.getNumber();
      return phoneNumber ? phoneNumber.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), AsYouType2;
}();
function formatIncompletePhoneNumber$1(value, optionsOrDefaultCountry, metadata) {
  return metadata || (metadata = optionsOrDefaultCountry, optionsOrDefaultCountry = void 0), new AsYouType(optionsOrDefaultCountry, metadata).input(value);
}
function validatePhoneNumberLength() {
  return withMetadataArgument(validatePhoneNumberLength$1, arguments);
}
function formatIncompletePhoneNumber() {
  return withMetadataArgument(formatIncompletePhoneNumber$1, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray(o, minLen);
  }
}
function _arrayLikeToArray(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3], input, options = {}, metadata;
  if (typeof arg_1 == "string")
    isObject(arg_2) ? (arg_3 ? (options = arg_2, metadata = arg_3) : metadata = arg_2, isViablePhoneNumber(arg_1) ? input = parse(arg_1, void 0, metadata) : input = {}) : (arg_4 ? (options = arg_3, metadata = arg_4) : metadata = arg_3, isViablePhoneNumber(arg_1) ? input = parse(arg_1, {
      defaultCountry: arg_2
    }, metadata) : input = {});
  else if (isObject(arg_1))
    input = arg_1, arg_3 ? (options = arg_2, metadata = arg_3) : metadata = arg_2;
  else
    throw new TypeError("A phone number must either be a string or an object of shape { phone, [country] }.");
  return {
    input,
    options,
    metadata
  };
}
function isPossibleNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments), input = _normalizeArguments.input, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
  return !input.phone && !(options && options.v2) ? !1 : isPossiblePhoneNumber(input, options, metadata);
}
function isPossibleNumber() {
  return withMetadataArgument(isPossibleNumber$1, arguments);
}
function FlashFormInputPhoneNumber(props) {
  const {
    id,
    label,
    phoneNumber,
    defaultCountryCode = "US",
    selectedCountryCode,
    onChange,
    validationMessages,
    disabled,
    showOptionsInModal,
    autoFocus
  } = props, [inputWidth, setInputWidth] = useState(), { inputHasFocus, onInputBlur, onInputFocus } = useFlashInputFocus(), inputRef = useCallback((node) => {
    node && setInputWidth(node.getBoundingClientRect().width);
  }, []), phoneCountryOptions = usePhoneCountryOptions(), selectedCountry = selectedCountryCode ? phoneCountryOptions.countries[selectedCountryCode] : void 0, callingCodeLength = selectedCountry != null && selectedCountry.callingCode ? selectedCountry.callingCode.length : 2, leftPadSize = callingCodeLength === 2 ? "flashd-1350" : callingCodeLength === 3 ? "flashd-1500" : "flash-1600";
  function getFullNumber(num, callingCode) {
    return callingCode ? num ? `${callingCode}${num}` : callingCode : "";
  }
  function isValidPhoneNumber(fullNumber, countryCode) {
    return !!fullNumber && isPossibleNumber(fullNumber, countryCode);
  }
  function formatNumber(n) {
    return formatIncompletePhoneNumber(n, selectedCountryCode);
  }
  const formattedNumber = formatNumber(phoneNumber);
  function handlePhoneNumberChange(value) {
    const cleanPhoneNumber = parseIncompletePhoneNumber(value || ""), fullNumber = getFullNumber(cleanPhoneNumber, selectedCountry == null ? void 0 : selectedCountry.callingCode);
    onChange({
      selectedCountry,
      phoneNumber: cleanPhoneNumber,
      fullNumber,
      isValid: isValidPhoneNumber(fullNumber, selectedCountry == null ? void 0 : selectedCountry.countryCode)
    });
  }
  function handleClearButtonClick() {
    handlePhoneNumberChange();
  }
  function handleCountryChange(value) {
    const fullNumber = getFullNumber(phoneNumber, value == null ? void 0 : value.callingCode);
    onChange({
      selectedCountry: value,
      phoneNumber,
      fullNumber,
      isValid: isValidPhoneNumber(fullNumber, value == null ? void 0 : value.countryCode)
    });
  }
  function handleKeyDown(e) {
    e.code === "Backspace" && formattedNumber.endsWith(")") && (handlePhoneNumberChange(formatNumber(phoneNumber.slice(0, -1))), e.preventDefault()), isNumericKeyPress(e) && !validatePhoneNumberLength(getFullNumber(phoneNumber, selectedCountry == null ? void 0 : selectedCountry.callingCode)) && e.preventDefault();
  }
  return /* @__PURE__ */ jsx("div", { className: `${COMMON_CLASSNAME} flash-form-input-phone-number`, children: /* @__PURE__ */ jsx(
    FlashFormInputTextField,
    {
      id,
      label,
      type: "tel",
      value: formattedNumber,
      onChange: handlePhoneNumberChange,
      onKeyDown: handleKeyDown,
      onFocus: onInputFocus,
      onBlur: onInputBlur,
      inputClassName: `ps-${leftPadSize}`,
      inputRef,
      validationMessages,
      disabled,
      autoFocus,
      FieldPrefix: /* @__PURE__ */ jsxs(InputGroupText, { className: "ps-0 border-0", children: [
        /* @__PURE__ */ jsx(I18nextProvider, { i18n, children: /* @__PURE__ */ jsx(
          FlashFormInputPhoneNumberCountryCodeSelect,
          {
            id,
            defaultCountryCode,
            selectedCountryCode,
            onCountryChange: handleCountryChange,
            ...phoneCountryOptions,
            menuWidth: inputWidth,
            showOptionsInModal,
            disabled
          }
        ) }),
        selectedCountry && /* @__PURE__ */ jsx("span", { className: "ms-flash-050 text-tertiary", children: selectedCountry.callingCode })
      ] }),
      FieldSuffix: /* @__PURE__ */ jsx(
        FlashFormInputTextFieldModifierButtonClear,
        {
          id,
          disabled: !formattedNumber,
          onClick: handleClearButtonClick,
          inputHasFocus
        }
      )
    }
  ) });
}
function isNumericKeyPress(e) {
  return [...Array(10).keys()].map((k) => k.toString()).some((k) => e.key === k);
}
export {
  FlashFormInputPhoneNumber as default
};
//# sourceMappingURL=FlashFormInputPhoneNumber.js.map
